import React from "react";
import { Helmet as ReactHelmet } from "react-helmet";

function Helmet({ title = null, description = "Demo shop voor ShopCrate." }) {
    return (
        <ReactHelmet>
            <title>
                { title === null ? "ShopCrate Demo Shop" : (title + " - ShopCrate Demo Shop") }
            </title>
            <meta name="description" content={ description } />
        </ReactHelmet>
    );
}

export default React.memo(Helmet);
